import { Role } from 'generated/prisma/enums';

export const Roles = {
  [Role.ADMIN]: 'Administrador',
  [Role.USER]: 'Padrão',
};
